module.exports = __webpack_public_path__ + "media/assets/pngs/welcomeCarousel4-bcc8cc9a73cb24b1ac5ef1b4040faa74.png";